export default "__VITE_ASSET__CSBm0ANU__"